var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export default function Marker(props) {
    var children = props.children, highlighted = props.highlighted, modifier = props.modifier, visible = props.visible, x = props.x;
    return (_jsx("div", __assign({ className: "rt-marker rt-marker--".concat(modifier, " ").concat(visible ? 'rt-is-visible' : '', " ").concat(highlighted ? 'rt-is-highlighted' : ''), style: { left: "".concat(x, "px") } }, { children: _jsx("div", __assign({ className: "rt-marker__label" }, { children: _jsx("div", __assign({ className: "rt-marker__content" }, { children: children })) })) })));
}
